import React from 'react'

export default function JavaIcon() {
   return (
      <svg
         width="64"
         height="87"
         viewBox="0 0 64 87"
         fill="none"
         xmlns="http://www.w3.org/2000/svg"
      >
         <path
            d="M20.6125 67.1096C20.6125 67.1096 17.2963 69.0381 22.9724 69.6906C29.8489 70.4751 33.3634 70.3626 40.9413 68.9284C40.9413 68.9284 42.9335 70.1776 45.7159 71.2596C28.7283 78.5402 7.26958 70.8379 20.6125 67.1096ZM18.5367 57.6089C18.5367 57.6089 14.8173 60.362 20.4976 60.9496C27.8433 61.7074 33.6443 61.7694 43.6822 59.8365C43.6822 59.8365 45.0709 61.244 47.254 62.0138C26.7147 68.0197 3.8379 62.4874 18.5367 57.6089Z"
            fill="#1F473E"
         />
         <path
            d="M36.0355 41.4925C40.2212 46.3117 34.936 50.6485 34.936 50.6485C34.936 50.6485 45.5638 45.1618 40.6829 38.2912C36.1241 31.8838 32.6281 28.7005 51.554 17.7241C51.5543 17.7239 21.8466 25.1434 36.0355 41.4925Z"
            fill="#1F473E"
         />
         <path
            d="M58.5033 74.1365C58.5033 74.1365 60.9573 76.1588 55.8007 77.7228C45.9952 80.6932 14.9892 81.5902 6.37586 77.8414C3.27959 76.4942 9.08598 74.6249 10.9124 74.2326C12.8173 73.8196 13.9058 73.8965 13.9058 73.8965C10.4624 71.4708 -8.35073 78.6593 4.34965 80.7183C38.9854 86.3352 67.4876 78.1889 58.5033 74.1365ZM22.2067 47.7646C22.2067 47.7646 6.43504 51.5107 16.6215 52.871C20.9226 53.4468 29.4966 53.3165 37.4829 52.6474C44.0099 52.0968 50.5641 50.9264 50.5641 50.9264C50.5641 50.9264 48.2626 51.912 46.5975 53.0487C30.5817 57.2612 -0.357913 55.3014 8.54919 50.9928C16.0819 47.3516 22.2067 47.7646 22.2067 47.7646ZM50.499 63.5791C66.7798 55.1189 59.2525 46.9886 53.9981 48.0841C52.7103 48.3522 52.136 48.5844 52.136 48.5844C52.136 48.5844 52.6144 47.8355 53.527 47.5113C63.9214 43.857 71.9154 58.2893 50.1716 64.0057C50.1716 64.0057 50.424 63.7807 50.499 63.5791Z"
            fill="#1F473E"
         />
         <path
            d="M40.6832 0C40.6832 0 49.6997 9.01937 32.1314 22.8892C18.0433 34.0148 28.9188 40.3584 32.1255 47.6065C23.9023 40.1868 17.8674 33.6555 21.9161 27.5767C27.8584 18.6534 44.3211 14.3271 40.6832 0Z"
            fill="#1F473E"
         />
         <path
            d="M23.8067 86.504C39.4342 87.5044 63.4321 85.949 64.0002 78.5547C64.0002 78.5547 62.908 81.3577 51.0849 83.5841C37.7467 86.094 21.2954 85.8012 11.5381 84.1924C11.5386 84.192 13.5358 85.8454 23.8067 86.504Z"
            fill="#1F473E"
         />
      </svg>
   )
}
